import { render, staticRenderFns } from "./ParametersShow.vue?vue&type=template&id=d95d2140&"
import script from "./ParametersShow.vue?vue&type=script&lang=js&"
export * from "./ParametersShow.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports